<div id="dialog-container">
  <h1 mat-dialog-title>{{ 'TITLE.RENEW_CHECK' | translate }}</h1>

  <mat-divider></mat-divider>

  @if (missingRequiredFields$ | async; as missingRequiredFields) {
    @if (missingRequiredFields.length > 0) {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
        <span>{{ 'MESSAGE.INSUFFICIENT_FIELDS_PERMISSIONS' | translate }}</span>
        <ul>
          @for (field of missingRequiredFields; track field.code) {
            <li>{{ field.label }}</li>
          }
        </ul>
      </mat-dialog-content>
      <mat-dialog-actions class="center">
        <button mat-raised-button matDialogClose="cancel" color="accent" id="dialog-cancel-button">
          {{ 'BUTTON.CANCEL' | translate }}
        </button>
      </mat-dialog-actions>
    } @else {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto"
                          [formGroup]="checkCharacteristicsForm">
        <div class="form-container">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'LABEL.CHECK_TYPE' | translate }}</mat-label>
            <input matInput
                   formControlName="type"
                   [required]="true"
                   [value]="checkCharacteristicsForm.controls.type.value"/>
          </mat-form-field>

          @if (assetTypeAllowsSpaceModule) {
            <mat-form-field appearance="outline">
              <mat-label>{{ 'LABEL.SPACE' | translate }}</mat-label>
              <input matInput
                     formControlName="space"
                     [required]="true"
                     [value]="checkToRenewSpaces.toString()"/>
            </mat-form-field>
          }

          <div class="button-container fx-layout-row fx-justify-end fx-align-center">
            <button [id]="'check-renew-cancel-button'" mat-stroked-button matDialogClose="cancel">
              {{ 'BUTTON.CANCEL' | translate }}
            </button>
            <button [id]="'check-renew-save-button'" color="accent" mat-raised-button matDialogClose="yes">
              {{ 'BUTTON.RENEW' | translate }}
            </button>
          </div>
        </div>
      </mat-dialog-content>
    }
  } @else {
    <spinner></spinner>
  }
</div>
